// @flow
import React, { Component, Fragment } from "react";
import { SwatchesPicker  } from "react-color";
import classNames from "classnames";
import InputLabel from "@material-ui/core/InputLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ButtonBase from "@material-ui/core/ButtonBase";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { withStyles } from "@material-ui/core/styles";

import type { StyledTextFieldClassesType } from "./StyledTextField";
import type { DictionaryType } from "../../types/GeneralTypes";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { iconStyles } from "../../styles/iconStyles";
import { InputStyles } from "./StyledTextField";
import { colorLabel } from "../../styles/generalStyles";
import GeneralModalForm from "../Gadgets/GeneralModalForm";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...InputStyles(theme),
  ...iconStyles(theme),
  colorLabel: {
    ...colorLabel,
    width: "70px",
    height: "24px",
    verticalAlign: "-30%"
  }
});

type ColorPickerPropsType = {
  classes: {
    ...StyledTextFieldClassesType,
    ...IconStylesClassesType,
    colorLabel: DictionaryType
  },
  label: string,
  name: string,
  value: string,
  onChange: Function,
  isInvalid?: boolean,
  isRequired?: boolean,
  isDisabled?: boolean
};

type ColorPickerStatesType = {
  isOpen: boolean
};

class ColorPicker extends Component<
  ColorPickerPropsType,
  ColorPickerStatesType
> {
  constructor(props: ColorPickerPropsType) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  openColorPicker = () => {
    this.setState({ isOpen: true });
  };

  handleRequestClose = () => {
    this.setState({ isOpen: false });
  };

  onChangeComplete = (color: *) => {
    this.handleRequestClose();
    this.props.onChange(this.props.name, color);
  };

  render(): * {
    const classes = this.props.classes;

    return (
      <Fragment>
        <FormControl
          fullWidth={false}
          error={this.props.isInvalid}
          disabled={this.props.isDisabled}
        >
          {this.props.label !== "" && (
            <InputLabel
              htmlFor={this.props.name}
              required={this.props.isRequired}
              error={this.props.isInvalid}
              shrink={true}
              classes={{
                root: classes.greenLabel,
                formControl: classes.textFieldFormLabel,
                focused: classes.labelFocused,
                error: classes.labelError,
                disabled: classes.labelDisabled
              }}
            >
              {this.props.label}
            </InputLabel>
          )}
          <ButtonBase
            focusRipple
            disabled={this.props.isDisabled}
            classes={{
              root: classNames(
                classes.textFieldRoot,
                classes.textFieldInput,
                this.props.isInvalid && classes.borderError
              )
            }}
            onClick={this.openColorPicker}
          >
            <span
              className={classes.colorLabel}
              style={{ backgroundColor: this.props.value }}
            />
            {this.state.isOpen ? (
              <ArrowDropUpIcon className={classes.greenIcon} />
            ) : (
              <ArrowDropDownIcon className={classes.greenIcon} />
            )}
          </ButtonBase>
        </FormControl>
        <GeneralModalForm
          title="Pick a Color"
          open={this.state.isOpen}
          handleModalStatus={this.handleRequestClose}
          notFullWidth
          form={
            <SwatchesPicker
              width={385}
              color={this.props.value}
              onChangeComplete={this.onChangeComplete}
            />
          }
        />
      </Fragment>
    );
  }
}

export default withStyles(styles)(ColorPicker);
